import React from 'react';
import { fabric } from 'fabric';
import GlobalEvents from '../event/GlobalEvents';
import initJSONCanvas from './../fabricjs/InitJSONCanvas.json';

class UtilsCanvas extends React.Component {
  
  static rectResize = {
    key: null,
    // ---------------------------
    typeName: "RectResize",
    width: 10000,
    height: 10000,
    left: 0,
    top: 0,
    // ---------------------------
    opacity: 0,
    fill: null,
    border: 0,
    borderWidth: 0,
    hoverCursor: "default",
    lockMovementX: true,
    lockMovementY: true,
    evented: false,
    hasControls: false,
    selectable: false,
    absolutePositioned: false,
    hasBorders: false,
    hasRotatingPoint: false,
    preserveObjectStacking: true,
    objectCaching: false,
  }

  static rectMP = {
    key: null,
    // ---------------------------
    typeName: "RectMP",
    width: 500,
    height: 500,
    left: 10,
    top: 10,
    // ---------------------------
    opacity: 1,
    fill: '#ffffff',
    stroke: null,
    strokeWidth: 0,
    border: 0,
    borderWidth: 0,
    hoverCursor: "default",
    lockMovementX: true,
    lockMovementY: true,
    evented: false,
    hasControls: false,
    selectable: false,
    absolutePositioned: false,
    hasBorders: false,
    hasRotatingPoint: false,
    preserveObjectStacking: true,
    objectCaching: false,
    // ---------------------------
    // document
    document: {
      // values
      name: '',
      label: '',
      note: '',
      tasks: {},
      show: true,
      // pattern
      pattern: { 
        fill: {
          name: false,
          code: false,
          url: false,
          scale: 1,
          angle: 0,
          padding: 0,
          offsetX: 0,
          offsetY: 0,  
          filters: [], // only 4K
        },
        stroke: {
          name: false,
          code: false,
          url: false,
          scale: 1,
          angle: 0,
          padding: 0,
          offsetX: 0,
          offsetY: 0,  
          filters: [], // only 4K
        }, 
      },
      pallete: {
        // fill
        fill: {
          name: false,
          code: false,
          hex: false,
        },
        // stroke
        stroke: {
          name: false,
          code: false,
          hex: false,
        },
      },
    },
  };

  constructor(props) {
    super(props);
    this.test = this.test.bind(this);
    this.center = this.center.bind(this);
  }

  test(log){
    console.log('test() ok',log);
  }
  
  //componentWillMount() {}
  //componentWillUnmount() {}
  //componentDidMount() {}
  //componentDidUpdate() {}
  //componentDidCatch() {}

  //-------------------------------------------------------------------------------------
  // Screen | Stage
  //-------------------------------------------------------------------------------------

  static getStageSize = ( c ) => {
    return { 
      // width: this.props.width, 
      // height: this.props.height,
      // width: this.state.sizes.widthStage, 
      // height: this.state.sizes.heightStage,
      width: c.getWidth(), 
      height: c.getHeight(),
      // width: c.width, 
      // height: c.height,
    };
  }

  //-------------------------------------------------------------------------------------
  // Position x,y
  //-------------------------------------------------------------------------------------

  static setPosition = ( c, x, y ) => {
    if (c === null) return 0;
    if (x === undefined) x = 0;
    if (y === undefined) y = 0;
    new UtilsCanvas().rotateReset( c );
    const { top, left } = c.hasOwnProperty('clipPath') && c.clipPath ? c.clipPath : { top:0, left:0 } ;
    return { top: (top + y) , left: (left + x) }
  }

  static setPositionLeft = ( c, x ) => {
    if (c === null) return 0;
    if (x === undefined) x = 0;
    new UtilsCanvas().rotateReset( c );
    //const clipW = c.clipPath !== undefined ? (c.clipPath.hasOwnProperty('width') ? c.clipPath.width : c.width) : c.width ;
    // const clipW = (c.clipPath !== undefined && c.clipPath !== undefined && c.clipPath.hasOwnProperty('width')) ? c.clipPath.getBoundingRect().width : c.width ;
    // const position = c.width / 2 - clipW / 2 + x;  
    return c.hasOwnProperty('clipPath') && c.clipPath ? c.clipPath.left + x : x ;
  }

  static setPositionTop = ( c, y ) => {
    if (c === null) return 0;
    if (y === undefined) y = 0;
    // const clipH = c.clipPath !== undefined ? (c.clipPath.hasOwnProperty('height') ? c.clipPath.height : c.height) : c.height ;
    // const clipH = (c.clipPath !== undefined && c.clipPath !== undefined && c.clipPath.hasOwnProperty('height')) ? c.clipPath.getBoundingRect().height : c.height ;
    // const position = c.height / 2 - clipH / 2 + y;  
    return c.hasOwnProperty('clipPath') && c.clipPath ? c.clipPath.top + y : y ;
  }

  //-------------------------------------------------------------------------------------
  // Canvas
  //-------------------------------------------------------------------------------------

  static isFine = ( c ) => {
    if (c === undefined || c === null) {
      return false;
    } else if (c.hasOwnProperty('isFabricCanvas')) {
      return true;
    } else {
      return true;
    }
  }

  static checkCanvas = ( c ) => {
    if(this.isFine( c ) === false)
      throw new Error('Can\'t find Canvas element');
  }

  // get canvas
  static getCanvas = ( c ) => {
    if (c !== undefined) {
      //this.setState({ ...this.state, canvas: c });
      return c;
    }
    else if (this.props){
      if(this.props.hasOwnProperty('canvas')){
        return this.props.canvas;
      }
    }
    else if (window.canvas !== undefined){
      //this.setState({ ...this.state, canvas: window.canvas });
      return window.canvas;
    } else {
      }
  }

  // get active object
  static getActiveObject = ( c ) => {
    this.renderAll( c );
    return c.getActiveObject() || undefined ;
  }

  // get active objectS - many
  static getActiveObjects = ( c ) => {
    this.renderAll( c );
    return c.getActiveObjects() || undefined ;
  }

  // discart active object
  static discardActiveObject = ( c ) => {
    c.discardActiveObject();
  }

  // set element selection
  static setActiveObject = ( c, o ) => {
    c.setActiveObject( o );
    const data = { 
      canvas: c,
      activeObject: ( o === undefined || o === null) ? null : o ,
      key: ( o === undefined || o === null) ? null : ( o.hasOwnProperty('key') ? o.key : null ) ,
    };
    GlobalEvents.dispatch('changeActiveObject', data);
    c.activeObjectKey = data.key;
    this.renderAll( c );
  }

  // get getObjects on canvas
  static getObjects = ( c ) => {
    return c.getObjects() || undefined ;
  }
  
  // re-render fabric
  static renderAll = ( c ) => {
    if( c === undefined || c === null ) return;
    try {
      c.requestRenderAll();      
      // c.renderAll();
      c.calcOffset();
      } catch (error) {}
  }

  // setSelection = (v) => {
  static enableSelection = (c, v) => {
    fabric.Object.prototype.selection = v === undefined ? true : v;
    c.set("selection", v);

    // fabric.Object.prototype.selectable = false;
    // fabric.Object.prototype.selection = false;
    // c.set('selection', false);
    // c.set('selectable', false);
    // c.selection = false;
    // c.selectable = false;
    // this.renderAll( c );

    // this.canvas.forEachObject(object => {
    //   object.selectable = false;
    //   object.evented = false;
    // });

  }
  
  // restart
  clear = ( c, settings, callback ) => {
    const data = initJSONCanvas; 
    c.loadFromJSON(data,()=>{
      c.setViewportTransform([
        1,0,0,
        1,0,0,
      ]);
      this.center( c );
      c.history.reset();
      GlobalEvents.dispatch('resizeCanvas');
      GlobalEvents.dispatch('reset', c );
      GlobalEvents.dispatch('changeActiveObject',{ c:null, activeObject:null, key:null });
      if(callback !== undefined){
        callback();
      }
    });
  }

  //get element by id
  static getElementById = (c, id) => {
    return this.getElementByName(c, id);
  }

  //get element by name
  static getElementByName = (c, name) => {
    return [...c.getObjects()].find((el) => {
      if (el.hasOwnProperty('name') === false)
        return false;
      else if (el.name && el.name === name)
        return true;
      else
        return false;
    });
    /*
    return objects.map((el) => {
      if (el.hasOwnProperty('name') === false)
        return null;
      else if (el.name && el.name === name)
        return el;
      else
        return null;
    });
    */ 
  }

  //get element by key
  static getElementByKey = (c, key, callback) => {
    let object = [...c.getObjects()].find((el) => {
        if (el.hasOwnProperty('key') === false)
          return false;
        else if (el.key && el.key === key)
          return true;
        else
          return false;
      });

    if (callback !== undefined)
      callback({
        success: object === null ? false : true,
        fail: object === null ? true : false,
        object: object
      });
    return object;
  }

  //get element by key
  static getElementByTypeName = (c, value, callback) => {
    const prop = 'typeName';
    let objects = [...c.getObjects()].filter((el) => {
        if (el.hasOwnProperty(prop) === false)
          return false;
        else if (el[prop] && el[prop] === value)
          return true;
        else
          return false;
      });

    if (callback !== undefined)
      callback({
        success: objects.length === 0 ? false : true,
        fail: objects.length === 0 ? true : false,
        objects: objects
      });
    return objects;
  }

  static add = (c, el) => {

    el.set({
      // document
      document: {
        // values
        name: '',
        label: '',
        note: '',
        tasks: {},
        show: true,
        // pattern
        pattern: { 
          fill: {
            name: false,
            code: false,
            url: false,
            scale: 1,
            angle: 0,
            padding: 0,
            offsetX: 0,
            offsetY: 0,  
            filters: [], // only 4K
          },
          stroke: {
            name: false,
            code: false,
            url: false,
            scale: 1,
            angle: 0,
            padding: 0,
            offsetX: 0,
            offsetY: 0,  
            filters: [], // only 4K
          }, 
        },
        pallete: {
          // fill
          fill: {
            name: false,
            code: false,
            hex: false,
          },
          // stroke
          stroke: {
            name: false,
            code: false,
            hex: false,
          },
        },
      },
    });

    // para event.target. funcionar dentro do grupo
    // isso ajudará a fazer uma edição dentro do grupo
    // https://stackoverflow.com/questions/34047094/fabricjs-catch-click-on-object-inside-group/43397576
    // subTargetCheck: true
    // para que o objecto fique na frente precisa mudar no canvas:
    // c.preserveObjectStacking: false

    // console.log( el.document.pattern.fill.name );
    // console.log( el.document.pattern.stroke.name );
    // console.log( el.document.pallete.fill.name );
    // console.log( el.document.pallete.stroke.name );
    // console.log( el );

    c.add( el );
    this.renderAll( c );
  }

  static remove = (c, el) => {
    c.discardActiveObject();
    // multiples removes
    if( Array.isArray( el ) ){
      el.forEach( rm => c.remove( rm ) );
    } else { // single remove
      c.remove( el );
    }
    this.renderAll( c );
  }

  static key = (len) => {
    len = len === undefined ? 20 : len;
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charLen = characters.length;
    for (let i = 0; i < len; i++) {
      result += characters.charAt(Math.floor(Math.random() * charLen));
    }
    return result;
  };

  static set = (c, settings, callback) => {

    if ( settings === null || settings === undefined || typeof settings !== 'object' ) return;

    let object, objects;
    
    // has object on settings
    if( settings.hasOwnProperty('object') && settings.object ){
      object = settings.object;
    } else {
      // or get active object
      object = c.getActiveObject();
    } 

    // convetional set
    if ( settings.hasOwnProperty("conventionalSet") && settings.conventionalSet === true ) {
      object.set(settings);
      return;
    }

    // objects in array
    if ( object.hasOwnProperty('_objects') && object._objects ) {
      objects = object._objects;
    } else {
      objects = [object];
    }

    const { typeName } = object;

    // forEach elements
    objects.forEach( el => {

      // forEach settings
      for (let prop in settings) {

        // discart object key and continue
        if (prop === 'object') continue;

          if( 
            typeName === 'SVG' || 
            typeName === 'Image' || 
            typeName === 'Group' || 
            typeName === 'Circle'
          ){
          
          if (prop === "width") {
            console.log('SET:WIDTH');
            // rescale width
            try {
              console.log('SET:scaleToWidth');
              object.scaleToWidth(settings.width);              
              console.log('SET:scaleToWidth:end');
            } catch (error) {
              console.log('SET:scaleX');
              const proportional = settings.width / object.get('width');
              if( typeName === 'Image' ){
                console.log('SET:scaleX:Image');
                const boundingRectFactor = object.getBoundingRect().width / object.getScaledWidth();
                const scale = proportional / boundingRectFactor;
                object.set({ 
                  scaleX: scale,
                  scaleY: scale,
                 });
              } else if( typeName === 'SVG' ){
                console.log('SET:scaleX:SVG');
                object.set({ 
                  scaleX: proportional,
                  scaleY: proportional,
                });
              }
              // object.set({ scale: settings.width / el.width });
              console.log('SET:scaleX:end');
            }
          } else if (prop === "height") {
            // rescale height
            try {
              object.scaleToHeight(settings.height);
            } catch (error) {
              console.log('SET:scaleY');
              const proportional = settings.height / object.get('height');
              if( typeName === 'Image' ){
                console.log('SET:scaleY:Image');
                const boundingRectFactor = object.getBoundingRect().height / object.getScaledHeight();
                const scale = proportional / boundingRectFactor;
                object.set({ 
                  scaleX: scale,
                  scaleY: scale,
                 });
              } else if( typeName === 'SVG' ){
                console.log('SET:scaleY:SVG');
                object.set({ 
                  scaleX: proportional,
                  scaleY: proportional,
                });
              }
              // object.set({ scale: settings.width / el.width });
              console.log('SET:scaleX:end');
            }
          } else if (prop === "scale") {
            // scale
            object.scale(settings.scale);
            //scale and opacity
          } else if (prop === "angle" || prop === "opacity" || prop === "scaleX" || prop === "scaleY") {
            object.set(prop, settings[prop]);
            //} else if (object._objects[i].hasOwnProperty(prop)) {
          } else {
            // conventional set
            el.set(prop, settings[prop]);
            console.log("conventional:set(1)!");
          }

        }else {
          // conventional set
          el.set(prop, settings[prop]);
          console.log("conventional:set(2)!");
        }

      } // for
    }); // forEach

    object.setCoords();
    UtilsCanvas.renderAll( c );
    // c.history.register();
  }

  static enableObjects = ( c, enabled, objects) => {

    enabled = enabled || true;
    objects = objects || c._objects;

    objects.map((o) => {
      o.isLockForDraw = enabled ? true : null;
      o.hoverCursor = enabled ? "auto" : "default";
      o.evented = enabled;
      o.hasControls = enabled;
      o.selectable = enabled;
      return o;
    });

    UtilsCanvas.discardActiveObject( c );
    UtilsCanvas.renderAll( c );
    //####createLayer() --> Layer.refresh();
  };

  // never static
  center = ( c ) => {
    if( c === undefined || c === null ) return;
    const elements = c.getObjects();
    if( c.hasOwnProperty('clipPath') && c.clipPath !== undefined && c.clipPath !== null ){
      elements.push(c.clipPath);
    }
    const group = new fabric.Group(elements);
    c.centerObject(group)
    group.setCoords(); // error
    group.destroy();
    c.requestRenderAll();  
  }

  // never static
  rotate = ( c, angle ) => {
    if( c === undefined || c === null ) return;
    angle = angle === undefined ? 0 : angle ;
    const elements = c.getObjects(); // no change this
    if( c.hasOwnProperty('clipPath') && c.clipPath !== undefined && c.clipPath !== null ){
      elements.push(c.clipPath);
    }
    const group = new fabric.Group(elements);
    group.rotate(angle)
    c.centerObject(group)
    group.setCoords(); // error
    group.destroy()
    c.requestRenderAll();  
  }

  /** rotate angle zero, reset to zero */
  rotateReset = ( c ) => {
    if( c === undefined || c === null ) return;
    if( c.clipPath === undefined || c.clipPath === null ) return;
    const {angle} = c.clipPath;
    const elements = c.getObjects(); // no change this
    elements.push(c.clipPath);
    const group = new fabric.Group(elements);
    group.rotate( angle === undefined ? 0 : angle * -1 )
    c.centerObject(group)
    // group.setCoords();
    group.destroy()
    c.requestRenderAll();  
  }

  /** zoom scale to 1:1, reset to 1 */
  zoomReset = ( c ) => {
    if( c === undefined || c === null ) return;
    c.setViewportTransform([1,0,0,1,0,0]); 
    c.requestRenderAll();  
  }

  // static centerContainer = ( c ) => {

  //   // desabilitar todos os elementos selecionados
  //   c.discardActiveObject();

  //   // clipPath
  //   let cp = undefined;

  //   //centralize clip, caso exista um clip np canvas (clip = mask/mascara)
  //   if(c.clipPath !== undefined && c.clipPath !== null){

  //     if(c.clipPath.hasOwnProperty('width')){
  //       cp = c.clipPath;
  //     }else{
  //       cp = { width:c.width, height:c.height };
  //     }
  //     // valGlobal.sizes.widthClip = cp.width;
  //     // valGlobal.sizes.heightClip = cp.height;

  //     console.log('clipPath:');

  //     //se o tamanho do canvas for igual ao ClipPath entao o point(x,y) do clip é zero = 0
  //     if(parseInt(c.width) === parseInt(cp.width) && parseInt(c.height) === parseInt(cp.height)){
  //       cp.left = cp.top = 0;
  //     }else{ // centralizao o clip
  //       cp.left = this.setPositionLeft( c );
  //       cp.top  = this.setPositionTop( c );
  //     }

  //     c.clipPath = undefined;
  //     c.clipPath = cp;
  //     cp.setCoords();
  //     console.log('center:clipPath('+cp.width+'x'+cp.height+')');

  //   }
    
  //   //group all the objects
  //   let allTogether = new fabric.Group( c._objects );    // allTogether.left = 100;
  //   c.centerObject( allTogether );
  //   setTimeout(() => {
  //     // allTogether.left = 100;
  //     // allTogether.top = 50;
  //     allTogether.set("angle", 0); // why ???
  //     allTogether.destroy();
  //   }, 500);

  // }

  static focus = () => {

    const element = document.getElementById('canvas');
    //console.log('focusCanvas',element);

    try {
      // first try
      element.focus();
      element.click();
    } catch (error) {
      console.log('focus1Error');      
    }

    try {
      // secod try
      const simpleEvent = new Event("click");
      element.focus();      
      element.dispatchEvent(simpleEvent);
    } catch (error) {
      console.log('focus2Error');
    }

    try {
      //third try
      const mouseEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
        simulate: true,
      });
      element.focus();      
      element.dispatchEvent(mouseEvent);
    } catch (error) {
      console.log('focus3Error');
    }

  }

  static addRectMP = ( c ) => {

    if( c === undefined || c === null ) return ;
    const rectMP = new fabric.Rect( {...this.rectMP, key: UtilsCanvas.key() } );
    this.add( c, rectMP );
    c.centerObject( rectMP );
    console.log("addRectMP()",rectMP);
    this.sendToBackRectMP( c, rectMP, true );

  }

  static sendToBackRectMP = ( c, object, discardActiveObject ) => {

    if (c === undefined || c === null) return;
    if (object === undefined || object === null) return;
    if (object.typeName !== 'RectMP') return;

    //object.set( this.rectMP );
    c.centerObject( object );
    c.sendToBack( object );  
    // up 1
    c.bringForward( object );  

    if ( discardActiveObject === true ) {
      c.discardActiveObject();
    }
    console.log("RectMP:sendToBack()");

  }

  static resizeRectMP = ( c, width, height ) => {
    if (c === undefined || c === null) return;
    if(width === undefined || height === undefined){
      if( c.hasOwnProperty('clipPath') && c.clipPath !== undefined && c.clipPath !== null ){
        width = c.clipPath.getBoundingRect().width;
        height = c.clipPath.getBoundingRect().height;
      }
    }
    const object = c.item(1);
    if(object.typeName === 'RectMP'){
      object.set({
        width: width,
        height: height,
      });
      c.centerObject(object);
    }else{
      this.getElementByTypeName( c, 'RectMP', (e) =>{
        if(e.success){
          console.log('getElementByTypeName',e.objects[0]);
        }
      });
    }
  }

  // react resize é para agrupar os elementos quando o navegador for redimensionado
  // agrupa tudo e centraliza na tela, reordenando o x e o y
  static addRectResize = ( c ) => {

    if( c === undefined || c === null ) return ;
    const rectResize = new fabric.Rect( {...this.rectResize, key: UtilsCanvas.key() } );
    this.add( c, rectResize );
    c.centerObject( rectResize );
    console.log("addRectResize()",rectResize);

  }

  static sendToBackRectResize = ( c, object, discardActiveObject ) => {

    if (c === undefined || c === null) return;
    if (object === undefined || object === null) return;
    if (object.typeName !== 'RectResize') return;

    //object.set( this.rectResize );
    c.centerObject( object );
    c.sendToBack( object );    

    if ( discardActiveObject === true ) {
      c.discardActiveObject();
    }
    console.log("RectResize:sendToBack()");

  }

  static bringToFrontBend = ( c, object ) => {

    if ( !c || !object ) return;
    if ( object.typeName !== 'Bend' ) return;

    c.bringToFront( object );

    console.log("Bend:sendBringToFront()");
  }

  //-------------------------------------------------------------------------------------
  //render(){ return () }
  //-------------------------------------------------------------------------------------


}
export default UtilsCanvas;

/*
const helper1 = () => {};
const helper2 = () => {};

export default {
  helper1,
  helper2
};
*/

//import { HelloChandu } from './helpers'
//import functions from './helpers' then functions.HelloChandu